import { PhoneCall } from "../types/PhoneCall";

export const phoneCallOutcomeLabels: Record<string, string> = {
  reached: "Erreicht",
  notReached: "Nicht erreicht",
  wrongContact: "Falscher Ansprechpartner",
  busy: "Besetzt",
  unassignedNumber: "Nummer nicht vergeben",
  canceled: "Selbst abgebrochen",
  technicalError: "Technischer Fehler",
};

export const phoneCallStatusLabels: Record<string, string> = {
  queued: "Verbindungsaufbau",
  ringing: "Klingelt",
  "in-progress": "Im Gespräch",
  completed: "Beendet",
  busy: "Besetzt",
  failed: "Fehlgeschlagen",
  "no-answer": "Nicht erreicht",
  canceled: "Abgebrochen",
};

export const isPhoneCallProcessing = (call: PhoneCall) =>
  call.processingStatus === "pending" || call.processingStatus === "processing";

export const phoneCallRecipientLabel = (call: PhoneCall) =>
  (call.recipientIdentifier && call.recipientLabel) || call.toNumber || "Unbekannt";

export const phoneCallOutcome = (call: PhoneCall) => call.outcome ?? ({
  busy: "busy", "no-answer": "notReached", canceled: "canceled", failed: "technicalError",
} as Record<string, string>)[call.callStatus ?? ""] ?? null;

export const filterPhoneCalls = (calls: PhoneCall[], recipient: string, caller: string, outcome: string) =>
  calls.filter((call) =>
    (!recipient || (call.recipientIdentifier ?? call.toNumber) === recipient)
    && (!caller || String(call.backofficeUserId) === caller)
    && (!outcome || phoneCallOutcome(call) === outcome),
  );
